import { backgrounJobUpdatesReducer, toolTipReducer } from 'src/app/state/background-jobs.state';

export const reducers = {    
  backgroundJobUpdates: backgrounJobUpdatesReducer,
  toolTipsData: toolTipReducer
};

